export * from './lib/menu.module';

export { AccredibleMenuComponent } from './lib/menu.component';
